module.exports = __webpack_public_path__ + "assets/bvmed-ico-pickdate.7230452c.svg";